import { cn } from '@/lib/utils';
import { Icon } from '../Icon';
import { icons } from '../icons';

type Props = {
  icon: keyof typeof icons;
  onClick: (e: Event) => void;
  isActive?: boolean;
  disabled?: boolean;
};

const EditorIcon: React.FC<Props> = ({ icon, onClick, isActive, disabled }) => {
  return (
    <button
      type="button"
      className={cn(
        'rounded-md hover:bg-gray-50 cursor-pointer p-1 dark:hover:bg-dark-gray-600',
        disabled ? 'opacity-50' : '',
        isActive ? 'text-primary-500' : 'text-gray-900 dark:text-dark-gray-200'
      )}
    >
      <Icon icon={icon} onClick={e => onClick(e as any)} />
    </button>
  );
};

export default EditorIcon;
